import { useState, useRef, useEffect } from "react";

export const useCellWidth = () => {
  const [cellWidth, setCellWidth] = useState<number>(0);
  const calendarRef = useRef<HTMLDivElement | null>(null);

  const handleCellSize = () => {
    if (calendarRef.current) {
      const firstCell = calendarRef.current.querySelector(".ant-picker-cell-inner") as HTMLElement;
      if (firstCell) {
        setCellWidth(firstCell.getBoundingClientRect().width);
      }
    }
  };

  useEffect(() => {
    handleCellSize();
    window.addEventListener("resize", handleCellSize);

    return () => {
      window.removeEventListener("resize", handleCellSize);
    };
  }, []);

  return { cellWidth, calendarRef };
};
